import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { rsvpConfirmation } from '../../../../../actions/PublicWebsiteActions';

const EMAIL_REG = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

class RsvpSuccessHeader extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPressToggle = this.handleKeyPressToggle.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);

    this.state = {
      email: '',
      isEmailValid: false,
      subscribe: true,
      submitted: false,
    };
  }

  componentWillMount() {
    const { email } = this.props;
    const isEmailValid = EMAIL_REG.test(email);
    if (email) {
      this.setState({
        email,
        isEmailValid
      });
    }
  }

  handleChange(e) {
    e.preventDefault();
    const { name, value } = e.currentTarget;
    const isEmailValid = EMAIL_REG.test(value);
    this.setState({
      [name]: value,
      isEmailValid
    });
  }

  handleToggle() {
    this.setState(prevState => ({
      subscribe: !prevState.subscribe
    }));
  }

  handleKeyPressToggle(e) {
    e.preventDefault();
    if (e.charCode === 32) {
      this.handleToggle();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { guestGroupId, onRsvpConfirmation, onResetGuestGroupv2 } = this.props;
    const { email, subscribe } = this.state;
    onRsvpConfirmation({ guest_group_id: guestGroupId, email, subscribe })
      .then(() => this.setState({ submitted: true }));
    setTimeout(onResetGuestGroupv2, 3000);
    return false;
  }

  handleReset() {
    this.setState({
      email: '',
      isEmailValid: false,
      subscribe: true,
      submitted: false,
    });
  }

  render() {
    const { email, isEmailValid, subscribe, submitted } = this.state;

    return (
      <form className="guest-rsvp-success-header" onSubmit={this.handleSubmit}>
        <div className="guest-rsvp-email-container">
          {submitted ? (
            <div className="guest-rsvp-email">
              <p className="success-message">
                We&#39;ve sent a copy of your RSVP to <strong>{email}</strong>
              </p>
              <div className="btn btn-primary btn-wide" onClick={this.handleReset}>
                Send Another Copy
              </div>
            </div>
          ) : (
            <div className="guest-rsvp-email">
              <p>
                Want an emailed copy of your RSVP?
              </p>
              <div className="margin-bottom-2x">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={email}
                  onChange={this.handleChange}
                  placeholder="youremail@zola.com"
                  tabIndex="0"
                />
              </div>
              <div className="form-group">
                <label id="marketing-checkbox-field2-label" className="checkbox-inline" htmlFor="marketing-checkbox-field2">
                  <input
                    type="checkbox"
                    name="subscribe"
                    id="marketing-checkbox-field2"
                    value={subscribe}
                    checked={subscribe} // eslint-disable-line
                    onChange={this.handleToggle}
                  />
                  <span className="input-override" role="checkbox" aria-checked={subscribe ? 'true' : 'false'} tabIndex="0" aria-labelledby="marketing-checkbox-field2-label" onKeyPress={this.handleKeyPressToggle}>
                    <i className="zolaicon zolaicon-checkmark" />
                  </span>
                  Send me wedding updates, special offers, and more.*
                </label>
              </div>
              {isEmailValid ? (
                <input type="submit" className="btn btn-primary btn-wide" value="Submit" />
              ) : (
                <input type="submit" className="btn btn-disabled btn-wide" disabled value="Submit" />
              )}
              <p className="small disclaimer margin-top">
                * By checking this box, you are accepting
                our <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use </a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              </p>
            </div>
          )}
        </div>
        <h2>Your RSVP</h2>
      </form>
    );
  }
}

RsvpSuccessHeader.propTypes = {
  guestGroupId: PropTypes.number,
  email: PropTypes.string,
  onRsvpConfirmation: PropTypes.func,
  onResetGuestGroupv2: PropTypes.func
};

const mapStateToProps = state => ({
  guestGroupId: state.publicWebsite.guestGroupRsvp.guest_group_id,
  email: state.publicWebsite.guestGroupRsvp.email,
});

const mapDispatchToProps = dispatch => ({
  onRsvpConfirmation: rsvpConfirmationRequest => dispatch(rsvpConfirmation(rsvpConfirmationRequest)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RsvpSuccessHeader);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/RsvpSuccessHeader.jsx